import { lazyWithPreload } from "utils/lazyWithPreload"
import { featureFlagIsActive } from "utils/featureFlags"
import { universalRoutes } from "./universal"

const LiveTrains = lazyWithPreload(() => import("pages/porterbrook/LiveTrains"))
const NetworkMapping = lazyWithPreload(() => import("pages/porterbrook/NetworkMapping"))
const FleetData = lazyWithPreload(() => import("pages/porterbrook/FleetData"))
const LostTimeInSectionTracks = lazyWithPreload(() => import("pages/porterbrook/LostTimeInSectionTracks"))
const AnalyticsAPIBilling = lazyWithPreload(() => import("pages/porterbrook/AnalyticsAPIBilling"))
const AnalyticsAPIDocs = lazyWithPreload(() => import("pages/porterbrook/AnalyticsAPIDocs"))

export const PBRoutes = [
  {
    path: "/",
    component: LiveTrains,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Live Trains" }] },
  },
  {
    path: "/network-mapping",
    component: NetworkMapping,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Network Mapping" }] },
  },
  // {
  //   path: "/lost-time-trains",
  //   component: LostTimeInSectionTrains,
  //   meta: {
  //     breadcrumb: [
  //       { parent: "Dashboard", label: "Lost Time in Section: Trains" },
  //     ],
  //   },
  //   disabled: !featureFlagIsActive("LTIS"),
  // },
  {
    path: "/lost-time-tracks",
    component: LostTimeInSectionTracks,
    meta: {
      breadcrumb: [{ parent: "Dashboard", label: "Lost Time in Section: Tracks" }],
    },
    disabled: !featureFlagIsActive("LTIS"),
  },
  {
    path: "/analytics-api-documentation",
    component: AnalyticsAPIDocs,
    meta: {
      breadcrumb: [{ parent: "Dashboard", label: "Rail Analytics API Documentation" }],
    },
  },
  {
    path: "/analytics-api-billing",
    component: AnalyticsAPIBilling,
    meta: {
      breadcrumb: [{ parent: "Dashboard", label: "Rail Analytics API Billing" }],
    },
  },
  {
    path: "/fleetdata",
    component: FleetData,
    meta: {
      breadcrumb: [{ parent: "Dashboard", label: "Fleet Data Catalog" }],
    },
  },
  ...universalRoutes,
]
